import { render } from "./doc-link.vue?vue&type=template&id=def6378a&ts=true"
import script from "./doc-link.vue?vue&type=script&lang=ts"
export * from "./doc-link.vue?vue&type=script&lang=ts"

import "./doc-link.vue?vue&type=style&index=0&id=def6378a&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__